export class BrowseConfig {
  component: string;
  multiple?: boolean = false;
  searchData?:any={};
  isEdit?: boolean = true;
  constructor(component: string) {
    this.component = component;
  }
}
